import React from 'react';

import Benefits from '@components/home/Benefits';
import ContentImageRow from '@components/libraryV2/ContentImageRow';
import ExamCategories from '@components/home/ExamCategories';
import Features from '@components/home/Features';
import FeatureSections from '@components/exams/shared/FeatureSections';
import HomeHero from '@components/home/HomeHero';
import Introduction from '@components/home/Introduction';
import Layout from '@components/layout';
import OrganizationSchema from '@components/home/OrganizationSchema';
import PassGuaranteedCta from '@components/libraryV2/PassGuaranteedCta';
import ResearchBasedLearningScience from '@components/home/ResearchBasedLearningScience';
import Reviews from '@components/libraryV2/Reviews';
import Seo from '@components/Seo';
import SeoProduct from '@components/home/SeoProduct';
import ThemeText from '@components/libraryV2/ThemeText';

import AnalyticsSvg from '@svg/generic/analytics.svg';
import FormativeAssessmentsSvg from '@svg/generic/formative-assessments.svg';
import IntelligentQuizzesSvg from '@svg/generic/intelligent-quizzes.svg';

const seo = {
  canonical: '/',
  description:
    'Achievable is the most effective way to ace your professional exams and boost your career. Study on the go from your phone or computer. Industry best pass rates.',
  keywords:
    'achievable, achievable sie, achievable gre, achievable usmle, achievable series 7',
  title: 'Professional exam prep to boost your career',
};

export const Head = () => (
  <>
    <OrganizationSchema />
    <Seo seo={seo} />
  </>
);

const Index = () => (
  <Layout>
    <SeoProduct />

    <HomeHero />

    <Reviews />

    <ExamCategories />

    <Benefits />

    <Introduction />

    <FeatureSections>
      <ContentImageRow
        image={<IntelligentQuizzesSvg />}
        title={
          <>
            Intelligent <ThemeText>quizzes</ThemeText>
          </>
        }
        titleSize="h2"
        titleTag="h2"
        tighten
        reverseBackground
        withBackground
      >
        Our study materials utilize carefully created review quizzes, which we
        individually track and map to the key concepts in each exam. This ensures
        you&apos;re fully prepared for all topics that your exam covers.
      </ContentImageRow>

      <ContentImageRow
        image={<FormativeAssessmentsSvg />}
        title={
          <>
            Formative <ThemeText>assessments</ThemeText>
          </>
        }
        titleSize="h2"
        titleTag="h2"
        reverse
        secondary
        tighten
      >
        As you learn, you&apos;re continually quizzed on both new and review material.
        This makes you much more likely to remember the information for the exam, and
        keeps you motivated as you see your performance improve.
      </ContentImageRow>

      <ContentImageRow
        image={<AnalyticsSvg />}
        title={
          <>
            Tracking and <ThemeText>analytics</ThemeText>
          </>
        }
        titleSize="h2"
        titleTag="h2"
        tighten
        reverseBackground
        withBackground
      >
        Our system gives complete visibility into what you know and what needs more work.
        We pick up on cues from your study habits and adjust your study schedule for the
        best results.
      </ContentImageRow>

      <ResearchBasedLearningScience />

      <Features />
    </FeatureSections>

    <ExamCategories size="dog" type="detailed" />

    <PassGuaranteedCta secondary />
  </Layout>
);

export default Index;
